export default __webpack_public_path__ + "static/media/fedex.6237a85d.svg";